import React, {useEffect} from 'react';

import shp from 'shpjs'

const L = window.L;

const buildShapeFileConfig = (config, setMapOptions) => {
    const shpFileConfig = {
      style: config.style || undefined,
      onEachFeature: config.onEachFeature || undefined,
      pointToLayer: config.pointToLayer || undefined,
      attributionString: config.attributionString
    };

    if (config.style) shpFileConfig['style'] = config.style;
    shpFileConfig['setMapOptions'] = setMapOptions
    
    if (config.onEachFeature) shpFileConfig['onEachFeature'] = (feature, layer) => {
      config.onEachFeature(feature, layer, setMapOptions)
    };
    return shpFileConfig
}

const MapShapefile = ({Map, layerConfig, setMapOptions}) => {
    let layer = null;

    const initShapefile = async function(config) {
        if (!config.url) return;
        const shapeFileAsGeoJson = await shp(config.url);
        const shpFileConfig = buildShapeFileConfig(config, setMapOptions)
        const shapefile = L.geoJSON(shapeFileAsGeoJson, shpFileConfig);

        Map.addLayer(shapefile);

        layer = shapefile
    }

    useEffect(() => {

        if (!Map) return;

        initShapefile(layerConfig)

        return function cleanup() {
            if (layer) layer.remove();
        }   

    }, [Map])

    return null;
};

export default MapShapefile;